'use client';

import { useTheme } from 'next-themes';
import { flushSync } from 'react-dom';

export function useThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme();

  function toggleTheme() {
    const nextTheme = resolvedTheme === 'dark' ? 'light' : 'dark';

    if (
      !document.startViewTransition ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setTheme(nextTheme);
      return;
    }

    document.startViewTransition(() => {
      flushSync(() => {
        setTheme(nextTheme);
      });
    });
  }

  return { toggleTheme, resolvedTheme };
}
